import Link from "next/link";
import React, { useMemo, useRef } from "react";
import styles from "./styles.scss";
import { DEFAULT_SPORT, WebSportItem } from "src/constants";
import { useReactiveVar } from "@apollo/client";
import { currentSport } from "src/services/ApolloService";

const getLinksForLeague = (league: WebSportItem) => {
  const links = [{ href: `/${league.url}/sharp-picks`, text: "Expert Picks" }];
  /** For NBA and NFL replace public betting with player props */
  if (["NBA", "NFL"].includes(league.key)) {
    links.push({ href: `/${league.url}/prop-picks`, text: "Player Props" });
  }

  if (!["NBA", "NFL"].includes(league.key)) {
    links.push({ href: `/${league.url}/public-betting`, text: "Public Betting" });
  }

  links.push({ href: `/${league.url}/best-bets`, text: "Trending Bets" });

  if (["Football", "Basketball"].includes(league.sport.name)) {
    links.unshift({ href: `/${league.url}/odds/totals-spread`, text: "Over / Under Picks" });
    links.push({ href: `/${league.url}/line-movement`, text: "Line Movement" });
  }

  if (league.sport.name === "Hockey") {
    links.unshift({ href: `/${league.url}/odds/totals-spread`, text: "Over / Under Picks" });
    links.push({ href: `/${league.url}/odds/ats-odds`, text: "Against the Spread Picks" });
  }

  if (league.sport.name === "Baseball") {
    links.unshift({ href: `/${league.url}/odds/totals-spread`, text: "Over / Under Picks" });
    links.push({ href: `/${league.url}/odds/run-line-odds`, text: "Against the Spread Picks" });
  }

  if (league.sport.name === "Soccer") {
    links.unshift({ href: `/${league.url}/odds/over-unders`, text: "Over / Under Picks" });
    links.push({ href: `/${league.url}/odds/spread`, text: "Against the Spread Picks" });
  }

  if (league.sport.name === "Tennis") {
    links.unshift({ href: `/${league.url}/odds/over-unders`, text: "Over / Under Picks" });
    links.push({ href: `/${league.url}/odds/ats-odds`, text: "Against the Spread Picks" });
  }

  // Unshift Model Bets after each sport unshift the Over / Under Pick tile because we want model bet to be first
  links.unshift({ href: `/${league.url}/odds`, text: "Model Bets" });

  return links;
};

const TileNav = () => {
  const league = useReactiveVar(currentSport) ?? DEFAULT_SPORT;
  const gridRef = useRef<any>(null);
  const links = useMemo(() => getLinksForLeague(league), [league.key]);
  return (
    <div className="page-tiles" ref={gridRef}>
      {links.slice(0, 6).map((link, idx) => (
        <Link passHref key={idx} href={link.href} legacyBehavior>
          <div className="page-tile">
            <img className="page-tile-img" src={`/TileNav/${league.key}${idx + 1}.jpg`} />
            <div className="page-tile-text">{link.text}</div>
          </div>
        </Link>
      ))}
      <style jsx>{styles}</style>
    </div>
  );
};

export default TileNav;
